import { Component, ErrorInfo, ReactNode } from "react";
import { AlertTriangle } from "lucide-react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    if (typeof window !== "undefined") window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    if (this.props.fallback) return this.props.fallback;
    return (
      <div className="flex flex-col items-center justify-center h-full bg-bg text-text p-6">
        <AlertTriangle size={42} className="text-red-500 mb-3" />
        <h2 className="text-lg font-semibold mb-1">Ocurrio un error inesperado</h2>
        <p className="text-sm text-muted mb-4 max-w-md text-center">
          {this.state.error?.message || "La interfaz se cayo. Recargar suele resolverlo."}
        </p>
        <button
          className="bg-accent text-white px-4 py-2 rounded hover:bg-blue-500"
          onClick={this.handleReload}
        >
          Recargar pagina
        </button>
      </div>
    );
  }
}
